import React from "react";
import { FaInstagram, FaFacebook, FaTwitter } from 'react-icons/fa'

const Footer = () => {
  return (
    <>
      <div class="main-footer">
        <div className="footer-top">
          <div className="footerlogo-img">
            <img src="/images/dedication_school_logo-removebg-preview.png" alt="" />
          </div>
          <div className="footer-content">
            <p>Have any questions?  </p>
            <p>
              Call Us: +91 7610316159, +91 7049346989  , Mail Us:
              dedication@gmail.com
            </p>
            <p>
              address : H. No. 20, Khejda Square, 66 Feet Road, behind Think Gas Petrol Pump, Maholi, Bhopal, Madhya Pradesh 462030
            </p>
          </div>
          {/* <div className="socialmedia-link">
            <div className="socialall">
              <a
                href="https://www.facebook.com/newwisdomschool/"
                target="_blank" rel="noreferrer"
              >
                <div className="alllink-soc">
                  <FaFacebook />
                </div>
              </a>
              <a
                href="/"
                target="_blank" rel="noreferrer"
              >
                {" "}
                <div className="alllink-soc">
                  <FaTwitter />
                </div>
              </a>
              <a
                href="https://www.instagram.com/dedicationschoolofexcellence"
                target="_blank" rel="noreferrer"
              >
                {" "}
                <div className="alllink-soc">
                  <FaInstagram />
                </div>
              </a>
            </div>
          </div> */}
          <div className="social-media-links">
            <a
              href="https://www.facebook.com/people/Dedication-School-Of-Excellence-Bhopal/61574436837083/"
              target="_blank"
              rel="noreferrer"
              className="social-icon"
            >
              <FaFacebook />
            </a>
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              className="social-icon"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.instagram.com/dedicationschoolofexcellence"
              target="_blank"
              rel="noreferrer"
              className="social-icon"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© All Rights Reserved by, Dedication School Of Excellence</p>
          <p className="footer-made">
            Made with <i class=" ri-heart-3-fill"></i> by{" "}
            <a href="https://maitretech.com/"> Maitretech Solution</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
